import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { getImgeUrl } from 'src/environments/environment';

@Component({
  selector: 'app-biography-details',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './biography-details.component.html',
  styleUrl: './biography-details.component.scss'
})
export class BiographyDetailsComponent {
  isToggled = false;
  id
  biography
  imageURL = getImgeUrl()
  constructor(
    public themeService: ThemeCustomizerService, 
    private activeRouter: ActivatedRoute, 
    private publicService: PublicServiceService, 
  ) {
      this.themeService.isToggled$.subscribe(isToggled => {
          this.isToggled = isToggled;
      });
  }

  toggleTheme() {
      this.themeService.toggleTheme();
  }

  ngOnInit(): void {
    this.id = this.activeRouter.snapshot.params["id"]
    this.getData()
  }

  getData() {
    this.publicService.getRecordById(this.publicService.BIOGRAPHY_URL, this.id).subscribe({
      next: (res) => {
        this.biography = res
      },
      error: (err) => {
        console.log(err)
      }
    })
  }

}
